import theme from "@/constants/theme";

const styles: Record<string, React.CSSProperties> = {
  container: {
    maxHeight: "100vh",
    backgroundColor: theme.colors.background.primary,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1,
  },
  scrollContainer: {
    flexGrow: 1,
    padding: 16
  },
  title: {
    marginBottom: 24,
    color: theme.colors.text.title,
    textAlign: "center",
  },
  emotionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    flex: 1,
    maxHeight: "100%",
    overflowY: "auto",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    gap: 8,
  },
  backButton: {
    flex: 1,
    padding: "12px 16px",
    backgroundColor: "transparent",
    border: `1px solid ${theme.colors.primary}`,
    color: theme.colors.primary,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
  },
  nextButton: {
    flex: 1,
    padding: "12px 16px",
    backgroundColor: theme.colors.primary,
    color: theme.colors.text.default,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
    border: "none",
  },
  backButtonText: {
    textAlign: "center",
  },
  nextButtonText: {
    textAlign: "center",
  },
};

export default styles;
